// @ts-nocheck
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import {
  LayoutDashboard,
  GitBranch,
  Users,
  CalendarDays,
  Building2,
  Handshake,
  Megaphone,
  GraduationCap,
  BarChart3,
  Wrench,
  Settings,
  Star
} from 'lucide-react';

interface SalesSidebarProps {
  isOpen: boolean;
}

const sidebarItems = [
  {
    title: 'Dashboard',
    href: '/sales-dashboard',
    icon: LayoutDashboard,
  },
  {
    title: 'Lead Pipeline',
    href: '/sales-dashboard/pipeline',
    icon: GitBranch,
  },
  {
    title: 'Affiliates',
    href: '/sales-dashboard/affiliates',
    icon: Star,
  },
  {
    title: 'White Label Events',
    href: '/sales-dashboard/white-label',
    icon: CalendarDays,
  },
  {
    title: 'Teams & Organizations',
    href: '/sales-dashboard/teams',
    icon: Users,
  },
  {
    title: 'Partners',
    href: '/sales-dashboard/partners',
    icon: Handshake,
  },
  {
    title: 'Advertisers',
    href: '/sales-dashboard/advertisers',
    icon: Megaphone,
  },
  {
    title: 'College Coaches',
    href: '/sales-dashboard/college-coaches',
    icon: GraduationCap,
  },
  {
    title: 'Analytics & Reports',
    href: '/sales-dashboard/analytics',
    icon: BarChart3,
  },
  {
    title: 'Sales Tools',
    href: '/sales-dashboard/tools',
    icon: Wrench,
  },
  {
    title: 'Profile Settings',
    href: '/sales-dashboard/settings',
    icon: Settings,
  },
];

const SalesSidebar: React.FC<SalesSidebarProps> = ({ isOpen }) => {
  const location = useLocation();

  return (
    <aside
      className={cn(
        'bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 transition-all duration-300',
        isOpen ? 'w-64' : 'w-0 lg:w-16'
      )}
    >
      <div className="flex flex-col h-full p-4">
        <nav className="space-y-2">
          {sidebarItems.map((item) => {
            const isActive = location.pathname === item.href;
            
            return (
              <NavLink
                key={item.href}
                to={item.href}
                className={cn(
                  'flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700',
                  !isOpen && 'lg:justify-center'
                )}
              >
                <item.icon className="h-5 w-5 flex-shrink-0" />
                {(isOpen) && (
                  <span className="truncate">{item.title}</span>
                )}
              </NavLink>
            );
          })}
        </nav>
      </div>
    </aside>
  );
};

export default SalesSidebar;